
export const workflowtableheading = [
 
     "",
    "ID",
    "Workflow Name",
    "Rules",
    "% of Paid Invoices",
    "Description",
    "Action",
  ];
  
  
  
  export const workflowtabledata=[
      {
          workstatus:" ",
          id:"01",
          workflowname:'John',
          rules:'John',
          percentage:'Paid',
          description:'19 jan,2020',
          action:"",
         
      },
      {
        workstatus:" ",
        id:"02",
        workflowname:'John',
        rules:'John',
        percentage:'Paid',
        description:'19 jan,2020',
        action:"",
       
    },
    {
        workstatus:" ",
        id:"03",
        workflowname:'John',
        rules:'John',
        percentage:'Paid',
        description:'19 jan,2020',
        action:"",
       
    },
    {
        workstatus:" ",
        id:"04",
        workflowname:'John',
        rules:'John',
        percentage:'Paid',
        description:'19 jan,2020',
        action:"",
       
    },
    {
        workstatus:" ",
        id:"05",
        workflowname:'John',
        rules:'John',
        percentage:'Paid',
        description:'19 jan,2020',
        action:"",
       
    },
    {
        workstatus:" ",
        id:"06",
        workflowname:'John',
        rules:'John',
        percentage:'Paid',
        description:'19 jan,2020',
        action:"",
       
    },
    {
        workstatus:" ",
        id:"07",
        workflowname:'John',
        rules:'John',
        percentage:'Paid',
        description:'19 jan,2020',
        action:"",
       
    },
  ]
  
    
  